import React from "react";

const CanSendTagContext = React.createContext(true);

export default CanSendTagContext;
